import {
  factoryOrderAttentionKind,
  type FactoryBatch,
  type FactoryOrder,
} from '../services/factoryService';

const STORAGE_PREFIX = 'factory.attention.seen.v1:';

function storageKey(userId: string) {
  return `${STORAGE_PREFIX}${userId || 'anon'}`;
}

export function collectFactoryAttentionKeys(params: {
  orders: FactoryOrder[];
  pendingAuth?: FactoryBatch[];
  pendingRelease?: FactoryBatch[];
}): string[] {
  const keys: string[] = [];
  for (const order of params.orders || []) {
    const kind = factoryOrderAttentionKind(order);
    if (kind) keys.push(`order:${order.id}:${kind}`);
  }
  for (const batch of params.pendingAuth || []) {
    keys.push(`auth:${batch.id}`);
  }
  for (const batch of params.pendingRelease || []) {
    keys.push(`release:${batch.id}`);
  }
  return [...new Set(keys)].sort();
}

function readSeen(userId: string): Set<string> {
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.map((k) => String(k || '')).filter(Boolean));
  } catch {
    return new Set();
  }
}

function writeSeen(userId: string, seen: Set<string>) {
  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify([...seen].slice(-200)));
  } catch {
    /* soft */
  }
}

export function hasUnseenFactoryAttention(userId: string, keys: string[]): boolean {
  if (!keys.length) return false;
  const seen = readSeen(userId);
  return keys.some((k) => !seen.has(k));
}

export function markFactoryAttentionSeen(userId: string, keys: string[]) {
  if (!keys.length) return;
  const seen = readSeen(userId);
  for (const key of keys) seen.add(key);
  writeSeen(userId, seen);
}
